/**
 * 5rw-cookie-bridge.js — load on OG listicle page ONLY, BEFORE 5rw.js.
 * Mirrors quiz localStorage keys to .28pilates.com cookies so quiz-first variant can read completion.
 * Does not modify 5rw.js.
 */
(function () {
  'use strict';

  var COOKIE_DOMAIN = '.28pilates.com';
  var MAX_AGE_SEC = 30 * 24 * 60 * 60;
  var ANSWERS_KEY = 'tp_quiz_answers_v1';
  var DONE_COOKIE = 'tp_quiz_done_advertorial_5rw';
  var DONE_VAL = '1';
  var COMPLETION_PREFIX = 'tp_quiz_completed_';
  var KNOWN_FLAGS = [
    'tp_quiz_completed_advertorial_5rw',
    'tp_quiz_completed_5rw'
  ];
  var MAX_ANSWERS_COOKIE_LEN = 3500;

  var host = window.location.hostname || '';
  if (host.indexOf('28pilates') === -1) return;

  function setCookie(name, value) {
    try {
      var base = name + '=' + encodeURIComponent(value) +
        ';path=/;max-age=' + MAX_AGE_SEC + ';SameSite=Lax';
      document.cookie = base;
      if (host.indexOf('28pilates') !== -1) {
        document.cookie = base + ';domain=' + COOKIE_DOMAIN;
      }
    } catch (e) {}
  }

  function getCookie(name) {
    try {
      var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + escaped + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function listCompletionKeysFromStorage() {
    var keys = KNOWN_FLAGS.slice();
    var seen = {};
    keys.forEach(function (k) { seen[k] = true; });
    try {
      for (var j = 0; j < localStorage.length; j++) {
        var lk = localStorage.key(j);
        if (lk && lk.indexOf(COMPLETION_PREFIX) === 0 && !seen[lk]) {
          keys.push(lk);
          seen[lk] = true;
        }
      }
    } catch (e) {}
    return keys;
  }

  function mirrorQuizToCookies() {
    try {
      var raw = localStorage.getItem(ANSWERS_KEY);
      if (raw && raw.length <= MAX_ANSWERS_COOKIE_LEN) setCookie(ANSWERS_KEY, raw);
      var anyDone = false;
      listCompletionKeysFromStorage().forEach(function (flagKey) {
        if (localStorage.getItem(flagKey) === 'true') {
          setCookie(flagKey, 'true');
          anyDone = true;
        }
      });
      if (anyDone) setCookie(DONE_COOKIE, DONE_VAL);
    } catch (e) {}
  }

  function cookiesIndicateQuizDone() {
    if (getCookie(DONE_COOKIE) === DONE_VAL) return true;
    for (var i = 0; i < KNOWN_FLAGS.length; i++) {
      if (getCookie(KNOWN_FLAGS[i]) === 'true') return true;
    }
    try {
      var parts = (document.cookie || '').split(';');
      for (var j = 0; j < parts.length; j++) {
        var pair = parts[j].trim();
        var eq = pair.indexOf('=');
        if (eq === -1) continue;
        var name = pair.slice(0, eq);
        if (name.indexOf(COMPLETION_PREFIX) === 0 && decodeURIComponent(pair.slice(eq + 1)) === 'true') {
          return true;
        }
      }
    } catch (e) {}
    return false;
  }

  function ensureDefaultAnswersIfDone() {
    try {
      if (!cookiesIndicateQuizDone() || localStorage.getItem(ANSWERS_KEY)) return;
      var raw = JSON.stringify({
        answers: { 1: 'lose-weight', 2: 'beginner', 3: '30-or-less', 4: 'motivation' },
        completedAt: Date.now(),
        version: 1
      });
      localStorage.setItem(ANSWERS_KEY, raw);
      if (raw.length <= MAX_ANSWERS_COOKIE_LEN) setCookie(ANSWERS_KEY, raw);
    } catch (e) {}
  }

  function hydrateQuizFromCookies() {
    try {
      if (!localStorage.getItem(ANSWERS_KEY)) {
        var fromCookie = getCookie(ANSWERS_KEY);
        if (fromCookie) localStorage.setItem(ANSWERS_KEY, fromCookie);
      }
      var parts = (document.cookie || '').split(';');
      for (var i = 0; i < parts.length; i++) {
        var pair = parts[i].trim();
        var eq = pair.indexOf('=');
        if (eq === -1) continue;
        var name = pair.slice(0, eq);
        var val = decodeURIComponent(pair.slice(eq + 1));
        if (name.indexOf(COMPLETION_PREFIX) === 0 && val === 'true' && localStorage.getItem(name) !== 'true') {
          localStorage.setItem(name, 'true');
        }
      }
      if (getCookie(DONE_COOKIE) === DONE_VAL) {
        KNOWN_FLAGS.forEach(function (k) {
          if (localStorage.getItem(k) !== 'true') localStorage.setItem(k, 'true');
        });
      }
      ensureDefaultAnswersIfDone();
    } catch (e) {}
  }

  function onQuizStorageKey(key) {
    if (key === ANSWERS_KEY || (key && key.indexOf(COMPLETION_PREFIX) === 0)) {
      mirrorQuizToCookies();
    }
  }

  hydrateQuizFromCookies();
  mirrorQuizToCookies();

  var nativeSetItem = Storage.prototype.setItem;
  var nativeRemoveItem = Storage.prototype.removeItem;

  Storage.prototype.setItem = function (key, value) {
    nativeSetItem.apply(this, arguments);
    onQuizStorageKey(key);
  };

  Storage.prototype.removeItem = function (key) {
    nativeRemoveItem.apply(this, arguments);
    onQuizStorageKey(key);
  };

  setInterval(mirrorQuizToCookies, 2000);
  window.addEventListener('storage', function (e) {
    if (!e || !e.key) return;
    onQuizStorageKey(e.key);
  });

  window.tpOgQuizCookieBridge = {
    version: 1,
    mirror: mirrorQuizToCookies,
    hydrate: hydrateQuizFromCookies
  };
})();